/* @flow */

import * as React from 'react';

import styles from './TakeOver.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Hooks
import useFixed from 'src/shared/app/base/hook/useFixed';
import useModalStatusContext from 'src/shared/app/base/modal/hook/useModalStatusContext';
import {
  disableBodyScrolling,
  enableBodyScrolling,
} from 'src/shared/core/util/browserUtil';

// Utils
import { portalTakeOverId } from 'src/shared/app/base/constant/domConstants';

// Components
import Portal from 'src/shared/ui/component/misc/Portal';
import { FocusTrap } from '@mui/base';
import { useSelector } from 'react-redux';
import { selectMobileNavIsRegistered } from 'src/shared/app/nav/selector/navSelectors';
type Props = {
  children: React.Node,
  overMobileNav?: boolean,
};

const useStyles = createUseThemeStyles(styles);

const TakeOver = ({ children, overMobileNav = false }: Props): React.Node => {
  const { innerProps: fixed } = useFixed();

  const { modals: openedModals } = useModalStatusContext();
  const hasModals = openedModals.size > 0;

  const mobileNavIsRendered = useSelector(selectMobileNavIsRegistered);

  const classes = useStyles({
    noBottom: mobileNavIsRendered || overMobileNav,
  });

  React.useEffect(() => {
    disableBodyScrolling();

    return () => {
      enableBodyScrolling();
    };
  }, []);

  return (
    <Portal id={portalTakeOverId}>
      <div {...fixed} className={classes.root}>
        <FocusTrap open={!hasModals}>
          <div className={classes.takeOverContent}>{children}</div>
        </FocusTrap>
      </div>
    </Portal>
  );
};

export default React.memo<Props>(TakeOver);
